// extracted by mini-css-extract-plugin
export default {"lines":"line_lines__W9VMT","tile":"line_tile__wY9BC","correct":"line_correct__LSytm","close":"line_close__4C-fg","incorrect":"line_incorrect__k9Poe"};